module.exports = __webpack_public_path__ + "static/img/congratulation.cc989eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/congratulation.png
// module id = 5P/H
// module chunks = 2